<template>
  <SideMenuLayout title="Achats" :items="items">
    <slot/>
  </SideMenuLayout>
</template>

<script>
import SideMenuLayout from "@/components/SideMenuLayout.vue";

const ITEMS = [
  {to: '/purchases', label: 'Achats', icon: 'bag'},
  {to: '/purchase-suppliers', label: 'Fournisseurs', icon: 'building'},
  {to: '/purchase-articles', label: 'Articles', icon: 'box'},
  {to: '/purchase-logistics', label: 'Logistique', icon: 'truck'},
  {to: '/purchase-disbursements', label: 'Décaissements', icon: 'wallet'},
];

/**
 * Menu latéral des achats ; le contenu de la page se place à l'intérieur.
 */
export default {
  name: "PurchaseHeader",
  components: {SideMenuLayout},
  data() {
    return {items: ITEMS};
  },
};
</script>
